export default "__VITE_ASSET__mRbBIwvP__"